import LogoImage from "assets/images/logo.png";
import { useState } from "react";
import { classnameDefaults } from "utils/common";
import { Link } from "react-router-dom";
import { routes } from "routing/routes";
import Cambios from "./DialogContent/Cambios";
import wpLogo from "../../assets/images/whatsapp.png";
import igLogo from "../../assets/images/instagram.png";

import ComoPagar from "components/Footer/DialogContent/ComoPagar";
import MetodosEnvio from "components/Footer/DialogContent/MetodosEnvio";
import PoliticasDevolucion from "components/Footer/DialogContent/PoliticasDevolucion";
import DondeEstamos from "components/Footer/DialogContent/DondeEstamos";

import LogoDev from "assets/images/logo-dev.png";
import QR from "assets/images/qr-big.png";

const Footer = () => {
  const [whatsappPopupOpen, setWhatsappPopupOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [qrOpen, setQrOpen] = useState(false);
  const [dialogContent, setDialogContent] = useState(null);

  const handleDialogOpen = (component) => {
    setDialogContent(component);
    setDialogOpen(true);

    document.body.classList.add("fixed");
  };

  return (
    <>
      <div className={`qr_overlay ${classnameDefaults([qrOpen, "active"])}`}>
        <button onClick={() => setQrOpen(false)}>
          <i className="fas fa-times"></i>
        </button>
        <img src={QR} alt="Escanea y pagá" />
      </div>
      <div
        className={`pop-overlay ${classnameDefaults([dialogOpen, "active"])}`}
      >
        <i
          className="fas fa-times"
          onClick={() => {
            setDialogOpen(false);
            document.body.classList.remove("fixed");
          }}
        ></i>
        <div className="pop-box">{dialogContent}</div>
      </div>
      <footer>
        <div className="wrapper">
          <div className="cols">
            <div className="col col-1">
              <a href=".">
                <img src={LogoImage} alt="Logotipo Vanya & Chicago" />
              </a>
            </div>

            <div className="col col-2">
              <a onClick={() => handleDialogOpen(PoliticasDevolucion)}>
                Devolución
              </a>
              <a onClick={() => handleDialogOpen(MetodosEnvio)}>
                Métodos de envío
              </a>
              <a onClick={() => handleDialogOpen(Cambios)}>Cambios</a>

              <a onClick={() => handleDialogOpen(ComoPagar)}>Cómo Pagar</a>
              <a onClick={() => handleDialogOpen(DondeEstamos)}>
                Donde Estamos
              </a>
            </div>

            <div className="col col-3">
              <div>
                <p>info@vanyaychicago.com.ar</p>

                <p>Virrey del pino 2720, Belgrano (CABA).</p>
              </div>
            </div>
            <div className="col col-4">
              <div>
                {" "}
                <div>
                  {" "}
                  <a
                    className="contact-info"
                    href="https://api.whatsapp.com/send?phone=541150193968"
                    target="_blank"
                  >
                    {" "}
                    <img
                      className="logo-wsp"
                      src={wpLogo}
                      alt="logo de whatsapp"
                    />
                    + 11 50193968
                  </a>
                  <a className="contact-info alternative-wp"> + 11 31392468</a>
                </div>
                <a
                  className="contact-info"
                  href="https://www.instagram.com/vanyaychicago/"
                  target="_blank"
                >
                  <img src={igLogo} className="logo-ig" />
                  @vanyaychicago
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="under-footer">
        <div className="wrapper">
          <p>Todos los derechos reservados @ {new Date().getFullYear()}</p>
          <a href="https://athom.com.ar/" target="_blank">
            <img src={LogoDev} alt="Logo de Athom" />
          </a>
        </div>
      </div>
      <button
        className="whatsapp-opener"
        onClick={() => setWhatsappPopupOpen(true)}
      >
        <i className="fab fa-whatsapp"></i>
        <span>Chateá con nosotros!</span>
      </button>

      <div
        className={`whatsapp-container ${classnameDefaults([
          whatsappPopupOpen,
          "active",
        ])}`}
      >
        <div className="top">
          <i
            className="fas fa-times"
            onClick={() => setWhatsappPopupOpen(false)}
          ></i>
          <p>
            ¡Hola! Hacé click en nuestra marca y te responderemos lo antes
            posible
          </p>
        </div>
        <a
          className="bottom"
          href="https://api.whatsapp.com/send?phone=5491150193968"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fab fa-whatsapp"></i>
          <div>
            <span>Estamos para ayudarte</span>
            <p>vanyaychicago.com.ar</p>
          </div>
        </a>
      </div>
    </>
  );
};

export default Footer;
